export const dictionary = {
  ar: {
    seo: {
      homeTitle: "مجموعة أعمال العقار | عقارات سعودية فاخرة",
      homeDescription:
        "منصة عقارية سعودية فاخرة بتجربة حديثة، خريطة تفاعلية، وعرض وحدات مميزة للبيع والإيجار.",
      loginTitle: "تسجيل دخول الموظفين | مجموعة أعمال العقار",
      loginDescription: "بوابة دخول آمنة للموظفين لإدارة العقارات والطلبات.",
      registerTitle: "تسجيل حساب موظف | مجموعة أعمال العقار",
      registerDescription: "تسجيل موظفين عبر كود دعوة أو قائمة سماح مع موافقة الإدارة.",
      branchesTitle: "فروعنا | مجموعة أعمال العقار",
      branchesDescription: "استكشف فروع مجموعة أعمال العقار في الطائف ومكة عبر عرض فاخر على الخريطة.",
      dashboardTitle: "لوحة التحكم | مجموعة أعمال العقار",
      dashboardDescription: "إدارة العقارات والفريق والدعوات من لوحة احترافية آمنة.",
      propertyTitlePrefix: "تفاصيل العقار",
    },
    nav: {
      brand: "مجموعة أعمال العقار",
      home: "الرئيسية",
      branches: "فروعنا",
      properties: "العقارات",
      login: "دخول الموظفين",
      register: "تسجيل موظف",
      dashboard: "لوحة التحكم",
      logout: "تسجيل الخروج",
      switchTo: "EN",
    },
    dashboardNav: {
      dashboard: "لوحة القيادة",
      properties: "العقارات",
      addProperty: "إضافة عقار",
      leads: "العملاء المحتملون",
      settings: "الإعدادات",
      admin: "الإدارة",
    },
    hero: {
      title: "وجهتك الأولى للعقار في المنطقة الغربية",
      subtitle:
        "من الطائف إلى مكة وجدة ، نوفر لك أفضل الفرص السكنية والاستثمارية بمعايير احترافية.",
      primaryCta: "اكتشف الفرص الآن",
      secondaryCta: "بوابة الموظفين",
    },
    regions: {
      sectionTitle: "خريطة تفاعلية فاخرة لمنطقة مكة",
      sectionSubtitle:
        "تجربة تنقل بصرية مستوحاة من NEOM لاختيار المدن والأحياء الرئيسية داخل منطقة مكة.",
      all: "كل نطاق مكة",
      mapTitle: "الواجهة التفاعلية لمنطقة مكة",
      chipsTitle: "المناطق والأحياء",
      loadingMap: "جارٍ تحميل المناطق الفرعية...",
      makkah: "مكة المكرمة",
      riyadh: "الرياض",
      eastern: "المنطقة الشرقية",
      madinah: "المدينة المنورة",
      qassim: "القصيم",
      asir: "عسير",
      tabuk: "تبوك",
      jazan: "جازان",
    },
    mapExperience: {
      sectionTitle: "",
      sectionSubtitle: "حرّك الخريطة لتحديث النتائج فورًا حسب النطاق الظاهر، مع تجربة سلسة بين الخريطة والقائمة.",
      title: "نتائج ضمن نطاق الخريطة",
      subtitle: "استعرض العقارات حسب موقعها الفعلي، مع معاينة سريعة قبل فتح التفاصيل.",
      inViewLabel: "داخل النطاق",
      approximateLocation: "موقع تقريبي",
      viewDetails: "عرض التفاصيل",
      emptyInView: "لا توجد عقارات داخل النطاق الحالي. حرّك الخريطة أو غيّر مستوى التكبير.",
      mobileSheetTitle: "النتائج والمعاينة",
    },
    subAreas: {
      general: "عام",
      "makkah-city": "مكة",
      jeddah: "جدة",
      taif: "الطائف",
      qunfudhah: "القنفذة",
      lith: "الليث",
      aziziyah: "العزيزية",
      "al-shatea": "الشاطئ",
      "al-hada": "الهدا",
      rabigh: "رابغ",
      khulais: "خليص",
      "al-kamil": "الكامل",
      "al-jumum": "الجموم",
      bahrah: "بحرة",
      "al-muwayh": "المويه",
      "al-khurmah": "الخرمة",
      turbah: "تربة",
      ranyah: "رنية",
      maysan: "ميسان",
      adham: "أضم",
      "al-ardiyat": "العرضيات",
    },
    properties: {
      sectionTitle: "عقارات فاخرة مختارة",
      sectionSubtitle: "وحدات سكنية واستثمارية مصممة لمعايير الرفاهية السعودية الحديثة.",
      empty: "لا توجد عقارات متاحة حالياً في هذه المنطقة.",
      loading: "جارٍ تحميل العقارات...",
      sale: "للبيع",
      rent: "للإيجار",
      available: "متاح",
      sold: "مباع",
      rented: "مؤجر",
      price: "السعر",
      bedrooms: "غرف النوم",
      bathrooms: "دورات المياه",
      livingRooms: "غرف المعيشة",
      parking: "مواقف السيارات",
      area: "المساحة",
      landArea: "مساحة الأرض",
      landType: "نوع الأرض",
      zoning: "التصنيف التنظيمي",
      frontage: "واجهة الشارع",
      floorsCount: "عدد الأدوار",
      unitsCount: "عدد الوحدات",
      shopsCount: "عدد المحلات",
      propertyAge: "عمر العقار",
      yearsSuffix: "سنة",
      elevatorLabel: "مصعد",
      elevatorYes: "يوجد",
      elevatorNo: "لا يوجد",
      details: "عرض التفاصيل",
      contact: "تواصل الآن",
      locationMap: "موقع العقار",
      gallery: "معرض الصور",
      watchVideo: "مشاهدة الفيديو",
      noVideo: "لا يوجد فيديو لهذا العقار حالياً",
      videoDialogTitle: "فيديو جولة خارجية",
      videoDialogDescription: "شاهد الفيديو بدون مغادرة صفحة النتائج",
      notFound: "لم يتم العثور على العقار المطلوب.",
      back: "العودة للعقارات",
      detailsSection: "تفاصيل كاملة",
    },
    auth: {
      loginTitle: "دخول الموظفين",
      loginSubtitle: "نظام آمن بصلاحيات إدارية وموظفين",
      registerTitle: "تسجيل موظف جديد",
      registerSubtitle: "يتطلب كود دعوة أو قائمة سماح وموافقة الإدارة",
      fullName: "الاسم الكامل",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      inviteCode: "كود الدعوة",
      submitLogin: "تسجيل الدخول",
      submitRegister: "إرسال الطلب",
      pending: "تم إنشاء الحساب، بانتظار موافقة الإدارة.",
      approved: "تم إنشاء الحساب بنجاح.",
      firstAdmin: "أول حساب يُعتمد كمدير تلقائياً لأغراض التهيئة الأولية.",
      goToLogin: "لديك حساب؟ دخول الموظفين",
      goToRegister: "لا يوجد حساب؟ تسجيل موظف",
      logoutSuccess: "تم تسجيل الخروج بنجاح",
    },
    dashboard: {
      title: "لوحة إدارة العقارات",
      subtitle: "إدارة احترافية للوحدات، الصور، الدعوات، واعتماد الموظفين.",
      createProperty: "إضافة عقار",
      editProperty: "تعديل عقار",
      listTitle: "قائمة العقارات",
      noItems: "لا توجد عقارات بعد.",
      save: "حفظ",
      update: "تحديث",
      cancelEdit: "إلغاء التعديل",
      delete: "حذف",
      edit: "تعديل",
      uploadImages: "رفع الصور",
      propertyTitleAr: "العنوان (عربي)",
      propertyTitleEn: "Title (English)",
      descriptionAr: "الوصف (عربي)",
      descriptionEn: "Description (English)",
      locationAr: "الموقع (عربي)",
      locationEn: "Location (English)",
      region: "المنطقة",
      subArea: "المنطقة الفرعية / الحي",
      listingType: "نوع العرض",
      propertyType: "نوع العقار",
      availability: "حالة العقار",
      visibility: "إظهار العقار للزوار",
      visible: "مرئي",
      hidden: "مخفي",
      price: "السعر",
      bedrooms: "غرف النوم",
      bathrooms: "دورات المياه",
      livingRooms: "غرف المعيشة",
      parking: "مواقف السيارات",
      floorsCount: "عدد الأدوار",
      unitsCount: "عدد الوحدات",
      shopsCount: "عدد المحلات",
      hasElevator: "مصعد",
      propertyAge: "عمر العقار (بالسنوات)",
      yes: "نعم",
      no: "لا",
      area: "المساحة (م²)",
      landArea: "مساحة الأرض (م²)",
      streetFrontageType: "نوع واجهة الشارع",
      zoning: "التصنيف التنظيمي",
      zoningPlaceholder: "مثال: سكني، تجاري مختلط",
      optionalNone: "غير محدد",
      streetFrontageOptions: {
        "single-street": "شارع واحد",
        "two-streets": "شارعين",
        "three-streets": "ثلاثة شوارع",
        corner: "زاوية",
        "main-road": "طريق رئيسي",
      },
      fieldRequired: "يرجى تعبئة الحقول المطلوبة.",
      invalidArea: "يرجى إدخال مساحة صحيحة أكبر من صفر.",
      dynamicFieldRequired: "الحقل مطلوب: {field}",
      contactPhone: "رقم التواصل",
      imageUrls: "روابط صور إضافية (مفصولة بفاصلة)",
      invitePanel: "إدارة الدعوات وقائمة السماح",
      pendingUsers: "طلبات الموظفين المعلقة",
      approve: "اعتماد",
      noPending: "لا توجد طلبات معلقة.",
      inviteRole: "دور كود الدعوة",
      inviteDays: "صلاحية الكود (أيام)",
      inviteUses: "عدد الاستخدامات",
      createInvite: "إنشاء كود دعوة",
      allowlistEmail: "إضافة بريد إلى قائمة السماح",
      allowlistRole: "الدور",
      addAllowlist: "إضافة",
      invitesList: "أكواد الدعوة",
      allowlistList: "قائمة السماح",
      active: "نشط",
      inactive: "غير نشط",
      uploadButton: "رفع",
      staffOnly: "لا تملك صلاحية الوصول إلى هذه الصفحة.",
      roleStaff: "موظف",
      roleAdmin: "مدير",
      securityTitle: "إعدادات أمان الحساب",
      securitySubtitle: "يمكنك تغيير كلمة المرور فور تسجيل الدخول لتعزيز حماية الحساب.",
      temporaryPasswordAlert: "هذا الحساب يستخدم كلمة مرور مؤقتة. يجب تغييرها الآن.",
      currentPassword: "كلمة المرور الحالية",
      newPassword: "كلمة المرور الجديدة",
      confirmPassword: "تأكيد كلمة المرور الجديدة",
      changePassword: "تحديث كلمة المرور",
    },
    dashboardImageUpload: {
      title: "صور العقار",
      dropzoneTitle: "اسحب الصور هنا أو اخترها دفعة واحدة",
      dropzoneSubtitle: "يدعم JPG / PNG / WEBP مع تحسين تلقائي قبل الرفع",
      selectImages: "اختيار الصور",
      optimizing: "جارٍ تحسين الصور...",
      setAsCover: "تعيين كغلاف",
      cover: "الغلاف",
      statusUploading: "يرفع",
      statusSuccess: "تم",
      statusFailed: "فشل",
      retry: "إعادة المحاولة",
      uploading: "جارٍ رفع الصور...",
      success: "تم رفع الصور بنجاح",
      uploadFailed: "تعذر رفع الصور",
      partialFailed: "تم رفع بعض الصور وتعذّر رفع صور أخرى. يمكنك إعادة المحاولة لكل صورة.",
      advancedToggle: "خيارات متقدمة (روابط الصور اليدوية)",
      errors: {
        invalidType: "الملف غير مدعوم. استخدم JPG أو PNG أو WEBP فقط.",
        tooLargeOriginal: "حجم الملف كبير جداً. الحد الأقصى 20MB قبل التحسين.",
        tooLargeAfterOptimization: "الصورة ما زالت كبيرة بعد التحسين. حاول صورة أصغر.",
        optimizationFailed: "تعذر تحسين الصورة. يرجى المحاولة بصورة أخرى.",
      },
    },
    dashboardMapPicker: {
      sectionTitle: "موقع العقار على الخريطة",
      sectionSubtitle: "اضغط على الخريطة لوضع الدبوس، ثم اسحبه لضبط الموقع بدقة، أو ابحث باسم المكان.",
      searchPlaceholder: "ابحث عن عنوان أو مكان",
      mapLoading: "جارٍ تحميل الخريطة...",
      latitude: "خط العرض",
      longitude: "خط الطول",
      clearPin: "حذف الدبوس",
    },
    dashboardVideoUpload: {
      title: "فيديو العقار",
      dropzoneTitle: "اسحب ملف الفيديو هنا أو اختر ملفًا",
      dropzoneSubtitle: "يدعم MP4 / MOV. يتم الرفع فقط عند حفظ العقار",
      selectVideo: "اختيار فيديو",
      preview: "معاينة الفيديو",
      previewDescription: "يمكنك مراجعة فيديو العقار قبل الحفظ النهائي.",
      videoUrl: "رابط الفيديو",
      thumbnailUrl: "رابط الصورة المصغرة",
      previewUrl: "رابط فيديو معاينة قصير (اختياري)",
      replace: "استبدال",
      remove: "إزالة",
      noVideo: "لم يتم تحديد فيديو بعد",
      thumbnailAlt: "صورة مصغرة لفيديو العقار",
      uploading: "جارٍ رفع الفيديو...",
      success: "تم رفع الفيديو بنجاح",
      uploadFailed: "تعذر رفع الفيديو",
      errors: {
        invalidType: "صيغة الفيديو غير مدعومة. استخدم MP4 أو MOV.",
        tooLarge: "حجم الفيديو كبير جداً. الحد الأقصى 100MB.",
        validationFailed: "تعذر التحقق من ملف الفيديو.",
      },
    },
    dashboardOverview: {
      subtitle: "ملخص تشغيلي سريع لعقاراتك وطلبات الفريق.",
      totalProperties: "إجمالي العقارات",
      visibleProperties: "العقارات المرئية",
      saleProperties: "عقارات للبيع",
      rentProperties: "عقارات للإيجار",
      pendingRequests: "طلبات موظفين معلقة",
      quickActions: "إجراءات سريعة",
    },
    dashboardProperties: {
      subtitle: "استعرض العقارات مع البحث والتصفية والصفحات المرقمة.",
      filtersTitle: "البحث والتصفية",
      searchPlaceholder: "ابحث بالعنوان أو الموقع",
      all: "الكل",
      resetFilters: "إعادة التصفية",
      noResults: "لا توجد نتائج مطابقة للفلاتر الحالية.",
      previous: "السابق",
      next: "التالي",
      editProperty: "تعديل العقار",
      addEditSubtitle: "أدخل بيانات دقيقة للحفاظ على عرض احترافي للعقار.",
      backToProperties: "العودة إلى العقارات",
      propertyNotFound: "تعذر العثور على العقار المطلوب.",
      confirmDelete: "هل أنت متأكد من حذف هذا العقار؟",
    },
    dashboardLeads: {
      subtitle: "إدارة العملاء المحتملين الواردة من صفحة التواصل ضمن تجربة احترافية.",
      emptyTitle: "لا توجد رسائل عملاء حالياً",
      emptyDescription:
        "عند إرسال نماذج التواصل ستظهر هنا تلقائياً، مع إمكانية تحديث حالة المتابعة.",
      allStatuses: "كل الحالات",
      statusLabel: "الحالة",
      statusNew: "جديد",
      statusInProgress: "قيد المتابعة",
      statusClosed: "مغلق",
      statusUpdated: "تم تحديث حالة العميل",
      viewDetails: "عرض التفاصيل",
      leadDetailsTitle: "تفاصيل العميل المحتمل",
      detailSubtitle: "عرض كامل للرسالة وبيانات التواصل مع تحديث الحالة مباشرة.",
      backToLeads: "العودة لقائمة العملاء",
      sourceContactPage: "نموذج التواصل",
      notFound: "تعذر العثور على هذا العميل المحتمل.",
      adminOnly: "هذه الصفحة متاحة للمدير فقط.",
      whatsappPlaceholder:
        "هيكل تكامل واتساب جاهز مستقبلاً. لم يتم تفعيل الأتمتة حالياً حسب الطلب.",
    },
    dashboardSettings: {
      accountTitle: "معلومات الحساب",
      roleLabel: "الدور",
    },
    dashboardAdmin: {
      subtitle: "إدارة صلاحيات الفريق والدعوات وقائمة السماح من شاشة مخصصة.",
    },
    dashboardLayout: {
      drawerDescription: "قائمة تنقل لوحة التحكم على الجوال.",
    },
    footer: {
      companyDescription:
        "منصة عقارية سعودية فاخرة تقدم تجربة بحث واستكشاف حديثة تلائم السوق المحلي وتوجهاته المستقبلية.",
      quickLinks: {
        title: "روابط سريعة",
        home: "الرئيسية",
        map: "الخريطة",
        branches: "فروعنا",
        advancedSearch: "البحث المتقدم",
        contact: "تواصل",
      },
      contactTitle: "معلومات التواصل",
      location: "الطائف , مكة المكرمة - المملكة العربية السعودية",
      legal: {
        copyright: "© 2026 مجموعة أعمال العقار. جميع الحقوق محفوظة.",
        privacy: "سياسة الخصوصية",
        terms: "الشروط والأحكام",
      },
    },
    bottomNav: {
      home: "الرئيسية",
      map: "الخريطة",
      search: "بحث",
      favorites: "المفضلة",
      contact: "واتساب",
      favoritesPlaceholder: "ميزة المفضلة ستكون متاحة قريباً",
    },
    advancedSearch: {
      subtitle: "ابحث بدقة عبر الفلاتر المتقدمة وشارك الرابط بنفس المعايير.",
      filtersTitle: "معايير البحث المتقدم",
      showFilters: "إظهار المعايير",
      hideFilters: "إخفاء المعايير",
      allLabel: "الكل",
      propertyTypeStripTitle: "أنواع العقارات المتاحة",
      allRegions: "كل المناطق",
      allSubAreas: "كل المناطق الفرعية",
      anyListing: "بيع أو إيجار",
      anyPropertyType: "كل أنواع العقار",
      minPrice: "الحد الأدنى للسعر",
      maxPrice: "الحد الأعلى للسعر",
      minArea: "الحد الأدنى للمساحة",
      amenities: "المزايا",
      apply: "تطبيق البحث",
      reset: "إعادة تعيين",
      resultsLabel: "نتيجة",
      noResults: "لا توجد عقارات مطابقة لخيارات البحث الحالية.",
      propertyTypes: {
        villa: "فيلا",
        "floor-in-villa": "دور في فيلا",
        apartment: "شقة",
        building: "عمارة",
        "floor-in-building": "دور في عمارة",
        palace: "قصر",
        "rest-house": "استراحة",
        shop: "محل تجاري",
        land: "أرض",
        "residential-land": "أرض سكنية",
        "commercial-land": "أرض تجارية",
        "agricultural-land": "أرض زراعية",
        commercial: "تجاري",
      },
      amenityLabels: {
        pool: "مسبح",
        garden: "حديقة",
        "sea-view": "إطلالة بحرية",
        "smart-home": "منزل ذكي",
        gym: "نادي رياضي",
        majlis: "مجلس",
        security: "أمن",
        parking: "مواقف",
      },
    },
    contactPage: {
      title: "واجهة تواصل راقية وسريعة",
      subtitle: "شارك طلبك العقاري مع فريقنا وسنتواصل معك خلال وقت قصير.",
      cta: "تواصل معنا",
      infoTitle: "معلومات ممكن تهمك",
      workingHoursTitle: "ساعات العمل",
      workingHoursValue: "الأحد - الخميس | 9:00 ص إلى 7:00 م",
      serviceMessage:
        "نقدّم دعماً متخصصاً للاستشارات العقارية الفاخرة والفرص الاستثمارية في مناطق المملكة.",
      formTitle: "نموذج التواصل",
      fullName: "الاسم الكامل",
      phone: "رقم الجوال",
      email: "البريد الإلكتروني",
      message: "رسالتك",
      submit: "إرسال الرسالة",
      sending: "جارٍ الإرسال...",
      successTitle: "تم إرسال رسالتك بنجاح",
      successMessage: "سيقوم فريقنا بالتواصل معك قريباً.",
      errorTitle: "تعذر إرسال الرسالة",
      quickLinksTitle: "روابط سريعة",
      requiredError: "يرجى تعبئة جميع الحقول المطلوبة",
      phoneFormatError: "صيغة رقم الجوال غير صحيحة",
      minMessageError: "الرسالة يجب أن تكون 10 أحرف على الأقل",
      collapseQuickLinks: "إظهار/إخفاء الروابط",
    },
    branchesPage: {
      badge: "حضورنا الميداني في المنطقة الغربية",
      title: "فروعنا على خريطة واحدة",
      subtitle:
        "عرض بصري فاخر يربط فرعي مكة والطائف في مشهد واحد، مع معلومات التواصل والاتجاهات وساعات العمل.",
      statLabel: "فروع حالية",
      mapEyebrow: "Branch Atlas",
      mapTitle: "الخريطة التفاعلية للفروع",
      mapDescription:
        "اضغط على أي علامة داخل الخريطة لعرض معلومات الفرع، ثم افتح الاتجاهات مباشرة أو تواصل عبر واتساب.",
      openMaps: "فتح في الخرائط",
      whatsapp: "واتساب",
      approximateMapNotice:
        "موقع فرع مكة على الخريطة يعرض نطاق المدينة مؤقتًا إلى أن تتم إضافة العنوان التفصيلي.",
    },
    common: {
      loading: "جارٍ التحميل...",
      saveSuccess: "تم الحفظ بنجاح",
      updateSuccess: "تم التحديث بنجاح",
      deleteSuccess: "تم الحذف بنجاح",
      approveSuccess: "تم اعتماد المستخدم",
      inviteSuccess: "تم إنشاء كود الدعوة",
      allowlistSuccess: "تمت إضافة البريد إلى قائمة السماح",
      uploadSuccess: "تم رفع الصور بنجاح",
      requestFailed: "حدث خطأ غير متوقع، يرجى المحاولة لاحقاً",
      passwordChanged: "تم تغيير كلمة المرور بنجاح",
      passwordMismatch: "كلمتا المرور الجديدتان غير متطابقتين",
      search: "بحث",
      logout: "تسجيل الخروج",
    },
  },
  en: {
    seo: {
      homeTitle: "Aamal Al Aqar Group | Saudi Luxury Real Estate",
      homeDescription:
        "A premium Saudi real estate platform with interactive region map, elegant property discovery, and secure staff operations.",
      loginTitle: "Staff Login | Aamal Al Aqar Group",
      loginDescription: "Secure authentication portal for admin and staff operations.",
      registerTitle: "Staff Registration | Aamal Al Aqar Group",
      registerDescription: "Invite/allowlist-based staff onboarding with admin approval workflow.",
      branchesTitle: "Branches | Aamal Al Aqar Group",
      branchesDescription: "Explore Aamal Al Aqar Group branches in Taif and Makkah through a premium map presentation.",
      dashboardTitle: "Dashboard | Aamal Al Aqar Group",
      dashboardDescription: "Secure admin dashboard for properties, invites, and team approvals.",
      propertyTitlePrefix: "Property Details",
    },
    nav: {
      brand: "Aamal Al Aqar Group",
      home: "Home",
      branches: "Branches",
      properties: "Properties",
      login: "Staff Login",
      register: "Staff Register",
      dashboard: "Dashboard",
      logout: "Logout",
      switchTo: "AR",
    },
    dashboardNav: {
      dashboard: "Dashboard",
      properties: "Properties",
      addProperty: "Add Property",
      leads: "Leads",
      settings: "Settings",
      admin: "Admin",
    },
    hero: {
      badge: "Saudi Premium Real Estate Platform",
      title: "A Refined Real Estate Experience Built for Saudi Vision",
      subtitle:
        "From Riyadh to Makkah and the Eastern Province, discover signature residences and investment-grade opportunities.",
      primaryCta: "Browse Properties",
      secondaryCta: "Staff Portal",
    },
    regions: {
      sectionTitle: "Luxury Interactive Makkah Region Map",
      sectionSubtitle:
        "A NEOM-inspired visual navigation experience for key cities and premium sub-areas in Makkah Region.",
      all: "All Makkah Areas",
      mapTitle: "Makkah Region Interactive Surface",
      chipsTitle: "Cities & Sub-areas",
      loadingMap: "Loading sub-areas...",
      makkah: "Makkah",
      riyadh: "Riyadh",
      eastern: "Eastern Province",
      madinah: "Madinah",
      qassim: "Qassim",
      asir: "Asir",
      tabuk: "Tabuk",
      jazan: "Jazan",
    },
    mapExperience: {
      sectionTitle: "Airbnb-Style Interactive Property Map",
      sectionSubtitle: "Move the map to instantly refresh listings by current viewport with connected map-list browsing.",
      title: "Listings in Current Viewport",
      subtitle: "Explore properties by live map position with quick preview before opening full details.",
      inViewLabel: "in view",
      approximateLocation: "Approximate location",
      viewDetails: "View Details",
      emptyInView: "No properties found in this map viewport. Move or zoom the map to explore more.",
      mobileSheetTitle: "Results & Preview",
    },
    subAreas: {
      general: "General",
      "makkah-city": "Makkah",
      jeddah: "Jeddah",
      taif: "Taif",
      qunfudhah: "Qunfudhah",
      lith: "Lith",
      aziziyah: "Al Aziziyah",
      "al-shatea": "Al Shatea",
      "al-hada": "Al Hada",
      rabigh: "Rabigh",
      khulais: "Khulais",
      "al-kamil": "Al Kamil",
      "al-jumum": "Al Jumum",
      bahrah: "Bahrah",
      "al-muwayh": "Al Muwayh",
      "al-khurmah": "Al Khurmah",
      turbah: "Turbah",
      ranyah: "Ranyah",
      maysan: "Maysan",
      adham: "Adham",
      "al-ardiyat": "Al Ardhiyat",
    },
    properties: {
      sectionTitle: "Curated Luxury Listings",
      sectionSubtitle: "Carefully selected homes and investment assets for modern Saudi lifestyles.",
      empty: "No properties currently available in this region.",
      loading: "Loading properties...",
      sale: "For Sale",
      rent: "For Rent",
      available: "Available",
      sold: "Sold",
      rented: "Rented",
      price: "Price",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      livingRooms: "Living Rooms",
      parking: "Parking",
      area: "Area",
      landArea: "Land Area",
      landType: "Land Type",
      zoning: "Zoning",
      frontage: "Street Frontage",
      floorsCount: "Floors",
      unitsCount: "Units",
      shopsCount: "Shop Count",
      propertyAge: "Property Age",
      yearsSuffix: "Years",
      elevatorLabel: "Elevator",
      elevatorYes: "Yes",
      elevatorNo: "No",
      details: "View Details",
      contact: "Contact Now",
      locationMap: "Property Location",
      gallery: "Gallery",
      watchVideo: "Watch Video",
      noVideo: "No video is available for this property yet",
      videoDialogTitle: "Exterior Drone Video",
      videoDialogDescription: "Watch the video without leaving the listing page",
      notFound: "The requested property could not be found.",
      back: "Back to listings",
      detailsSection: "Full Property Details",
    },
    auth: {
      loginTitle: "Staff Login",
      loginSubtitle: "Secure role-based access for admin and staff",
      registerTitle: "Register New Staff",
      registerSubtitle: "Requires invite code or allowlist with admin approval",
      fullName: "Full Name",
      email: "Email",
      password: "Password",
      inviteCode: "Invite Code",
      submitLogin: "Sign In",
      submitRegister: "Submit Request",
      pending: "Account created. Waiting for admin approval.",
      approved: "Account created successfully.",
      firstAdmin: "The first account is auto-approved as admin for initial bootstrap.",
      goToLogin: "Already have an account? Staff Login",
      goToRegister: "Need access? Register staff",
      logoutSuccess: "Logged out successfully",
    },
    dashboard: {
      title: "Property Management Dashboard",
      subtitle: "Professional control of listings, images, invites, and team approvals.",
      createProperty: "Create Property",
      editProperty: "Edit Property",
      listTitle: "Property Inventory",
      noItems: "No properties yet.",
      save: "Save",
      update: "Update",
      cancelEdit: "Cancel Edit",
      delete: "Delete",
      edit: "Edit",
      uploadImages: "Upload Images",
      propertyTitleAr: "Title (Arabic)",
      propertyTitleEn: "Title (English)",
      descriptionAr: "Description (Arabic)",
      descriptionEn: "Description (English)",
      locationAr: "Location (Arabic)",
      locationEn: "Location (English)",
      region: "Region",
      subArea: "Sub-area / District",
      listingType: "Listing Type",
      propertyType: "Property Type",
      availability: "Availability",
      visibility: "Visibility",
      visible: "Visible",
      hidden: "Hidden",
      price: "Price",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      livingRooms: "Living Rooms",
      parking: "Parking",
      floorsCount: "Floors",
      unitsCount: "Units",
      shopsCount: "Shop Count",
      hasElevator: "Elevator",
      propertyAge: "Property Age (years)",
      yes: "Yes",
      no: "No",
      area: "Area (sqm)",
      landArea: "Land Area (sqm)",
      streetFrontageType: "Street Frontage Type",
      zoning: "Zoning",
      zoningPlaceholder: "Example: residential, mixed-use commercial",
      optionalNone: "Not specified",
      streetFrontageOptions: {
        "single-street": "Single street",
        "two-streets": "Two streets",
        "three-streets": "Three streets",
        corner: "Corner",
        "main-road": "Main road",
      },
      fieldRequired: "Please complete the required fields.",
      invalidArea: "Please enter a valid area greater than zero.",
      dynamicFieldRequired: "Required field: {field}",
      contactPhone: "Contact Phone",
      imageUrls: "Additional image URLs (comma-separated)",
      invitePanel: "Invite & Allowlist Administration",
      pendingUsers: "Pending Staff Requests",
      approve: "Approve",
      noPending: "No pending requests.",
      inviteRole: "Invite Role",
      inviteDays: "Validity (days)",
      inviteUses: "Max Uses",
      createInvite: "Create Invite",
      allowlistEmail: "Add email to allowlist",
      allowlistRole: "Role",
      addAllowlist: "Add",
      invitesList: "Invite Codes",
      allowlistList: "Allowlist",
      active: "Active",
      inactive: "Inactive",
      uploadButton: "Upload",
      staffOnly: "You do not have permission to access this page.",
      roleStaff: "Staff",
      roleAdmin: "Admin",
      securityTitle: "Account Security",
      securitySubtitle: "You can change your password immediately after login for stronger account security.",
      temporaryPasswordAlert: "This account is using a temporary password. Please change it now.",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm New Password",
      changePassword: "Update Password",
    },
    dashboardImageUpload: {
      title: "Property Images",
      dropzoneTitle: "Drag and drop images here or select multiple at once",
      dropzoneSubtitle: "Supports JPG / PNG / WEBP with automatic optimization before upload",
      selectImages: "Select Images",
      optimizing: "Optimizing images...",
      setAsCover: "Set as cover",
      cover: "Cover",
      statusUploading: "Uploading",
      statusSuccess: "Done",
      statusFailed: "Failed",
      retry: "Retry",
      uploading: "Uploading images...",
      success: "Images uploaded successfully",
      uploadFailed: "Failed to upload images",
      partialFailed: "Some images uploaded, but others failed. Retry only the failed ones.",
      advancedToggle: "Advanced (manual image URLs)",
      errors: {
        invalidType: "Unsupported file type. Please use JPG, PNG, or WEBP.",
        tooLargeOriginal: "File is too large. Maximum allowed size is 20MB before optimization.",
        tooLargeAfterOptimization: "Image is still too large after optimization. Please use a smaller image.",
        optimizationFailed: "Unable to optimize image. Please try a different file.",
      },
    },
    dashboardMapPicker: {
      sectionTitle: "Property location on map",
      sectionSubtitle: "Click on the map to place a pin, drag it to refine the exact spot, or search by place name.",
      searchPlaceholder: "Search for an address or place",
      mapLoading: "Loading map...",
      latitude: "Latitude",
      longitude: "Longitude",
      clearPin: "Clear pin",
    },
    dashboardVideoUpload: {
      title: "Property Video",
      dropzoneTitle: "Drag and drop the video file here or select a file",
      dropzoneSubtitle: "Supports MP4 / MOV. Upload happens when you save the property",
      selectVideo: "Select Video",
      preview: "Preview Video",
      previewDescription: "Review the property video before final save.",
      videoUrl: "Video URL",
      thumbnailUrl: "Thumbnail URL",
      previewUrl: "Short Preview URL (optional)",
      replace: "Replace",
      remove: "Remove",
      noVideo: "No video selected yet",
      thumbnailAlt: "Property video thumbnail",
      uploading: "Uploading video...",
      success: "Video uploaded successfully",
      uploadFailed: "Failed to upload video",
      errors: {
        invalidType: "Unsupported video format. Use MP4 or MOV.",
        tooLarge: "Video is too large. Maximum allowed size is 100MB.",
        validationFailed: "Unable to validate the video file.",
      },
    },
    dashboardOverview: {
      subtitle: "A quick operational snapshot for listings and team requests.",
      totalProperties: "Total Properties",
      visibleProperties: "Visible Properties",
      saleProperties: "For Sale",
      rentProperties: "For Rent",
      pendingRequests: "Pending Staff Requests",
      quickActions: "Quick Actions",
    },
    dashboardProperties: {
      subtitle: "Manage properties with URL-based search, filters, and pagination.",
      filtersTitle: "Search & Filters",
      searchPlaceholder: "Search by title or location",
      all: "All",
      resetFilters: "Reset Filters",
      noResults: "No listings match the current filters.",
      previous: "Previous",
      next: "Next",
      editProperty: "Edit Property",
      addEditSubtitle: "Maintain complete, accurate listing details for premium presentation.",
      backToProperties: "Back to Properties",
      propertyNotFound: "Requested property could not be found.",
      confirmDelete: "Are you sure you want to delete this property?",
    },
    dashboardLeads: {
      subtitle: "Manage incoming contact leads with structured status workflows.",
      emptyTitle: "No leads yet",
      emptyDescription:
        "Submitted contact forms will appear here automatically for follow-up.",
      allStatuses: "All Statuses",
      statusLabel: "Status",
      statusNew: "New",
      statusInProgress: "In Progress",
      statusClosed: "Closed",
      statusUpdated: "Lead status updated",
      viewDetails: "View Details",
      leadDetailsTitle: "Lead Details",
      detailSubtitle: "Full lead message and contact details with inline status updates.",
      backToLeads: "Back to Leads",
      sourceContactPage: "Contact Form",
      notFound: "This lead could not be found.",
      adminOnly: "This page is available to admin only.",
      whatsappPlaceholder:
        "WhatsApp automation structure is prepared for future integration. It is intentionally not active yet.",
    },
    dashboardSettings: {
      accountTitle: "Account Information",
      roleLabel: "Role",
    },
    dashboardAdmin: {
      subtitle: "Control team approvals, invite codes, and allowlist access in a dedicated admin area.",
    },
    dashboardLayout: {
      drawerDescription: "Mobile dashboard navigation drawer.",
    },
    footer: {
      companyDescription:
        "A premium Saudi real estate platform delivering refined discovery and high-end property navigation for modern buyers and investors.",
      quickLinks: {
        title: "Quick Links",
        home: "Home",
        map: "Map",
        branches: "Branches",
        contact: "Contact",
        advancedSearch: "Advanced Search",
      },
      contactTitle: "Contact",
      location: "Riyadh - Saudi Arabia",
      legal: {
        copyright: "© 2026 Aamal Al Aqar Group. All rights reserved.",
        privacy: "Privacy Policy",
        terms: "Terms",
      },
    },
    bottomNav: {
      home: "Home",
      map: "Map",
      search: "Search",
      favorites: "Favorites",
      contact: "WhatsApp",
      favoritesPlaceholder: "Favorites will be available soon",
    },
    advancedSearch: {
      subtitle: "Run precise property discovery with shareable URL-based filters.",
      filtersTitle: "Advanced Filters",
      showFilters: "Show filters",
      hideFilters: "Hide filters",
      allLabel: "All",
      propertyTypeStripTitle: "Available property types",
      allRegions: "All Regions",
      allSubAreas: "All Sub-areas",
      anyListing: "Sale or Rent",
      anyPropertyType: "All Property Types",
      minPrice: "Min Price",
      maxPrice: "Max Price",
      minArea: "Min Area",
      amenities: "Amenities",
      apply: "Apply Search",
      reset: "Reset",
      resultsLabel: "results",
      noResults: "No properties match the current search criteria.",
      propertyTypes: {
        villa: "Villa",
        "floor-in-villa": "Floor in Villa",
        apartment: "Apartment",
        building: "Building",
        "floor-in-building": "Floor in Building",
        palace: "Palace",
        "rest-house": "Rest House",
        shop: "Retail Shop",
        land: "Land",
        "residential-land": "Residential Land",
        "commercial-land": "Commercial Land",
        "agricultural-land": "Agricultural Land",
        commercial: "Commercial",
      },
      amenityLabels: {
        pool: "Pool",
        garden: "Garden",
        "sea-view": "Sea View",
        "smart-home": "Smart Home",
        gym: "Gym",
        majlis: "Majlis",
        security: "Security",
        parking: "Parking",
      },
    },
    contactPage: {
      title: "Premium & Fast Contact Experience",
      subtitle: "Share your request and our team will reach out with tailored support shortly.",
      cta: "Contact Us",
      infoTitle: "Helpful Information",
      workingHoursTitle: "Working Hours",
      workingHoursValue: "Sunday - Thursday | 9:00 AM to 7:00 PM",
      serviceMessage:
        "We provide specialized support for luxury real estate consultations and investment opportunities across Saudi regions.",
      formTitle: "Contact Form",
      fullName: "Full Name",
      phone: "Phone Number",
      email: "Email",
      message: "Your Message",
      submit: "Send Message",
      sending: "Sending...",
      successTitle: "Message sent successfully",
      successMessage: "Our team will contact you soon.",
      errorTitle: "Unable to send message",
      quickLinksTitle: "Quick Links",
      requiredError: "Please complete all required fields",
      phoneFormatError: "Invalid phone number format",
      minMessageError: "Message must be at least 10 characters",
      collapseQuickLinks: "Toggle quick links",
    },
    branchesPage: {
      badge: "Our western region presence",
      title: "Our branches, framed on one refined map",
      subtitle:
        "A premium branch presentation connecting Taif and Makkah with contact details, directions, and working hours.",
      statLabel: "active branches",
      mapEyebrow: "Branch Atlas",
      mapTitle: "Interactive branch map",
      mapDescription:
        "Tap any marker on the map to preview branch details, then open directions or continue the conversation on WhatsApp.",
      openMaps: "Open in Maps",
      whatsapp: "WhatsApp",
      approximateMapNotice:
        "The Makkah branch marker currently reflects the city area until the precise branch address is added.",
    },
    common: {
      loading: "Loading...",
      saveSuccess: "Saved successfully",
      updateSuccess: "Updated successfully",
      deleteSuccess: "Deleted successfully",
      approveSuccess: "User approved successfully",
      inviteSuccess: "Invite code generated",
      allowlistSuccess: "Email added to allowlist",
      uploadSuccess: "Images uploaded successfully",
      requestFailed: "Unexpected error, please try again",
      passwordChanged: "Password changed successfully",
      passwordMismatch: "New password and confirmation do not match",
      search: "Search",
      logout: "Logout",
    },
  },
};

export const rtlLanguages = ["ar"];

export const getDir = (lang) => (rtlLanguages.includes(lang) ? "rtl" : "ltr");

export const getLangPrefix = (lang) => (lang === "en" ? "/en" : "/ar");

export const localizePath = (lang, path = "") => `${getLangPrefix(lang)}${path}`;

export const switchLanguagePath = (pathname, nextLang) => {
  const withoutPrefix = pathname.replace(/^\/(ar|en)/, "") || "";
  const finalPath = withoutPrefix.startsWith("/") ? withoutPrefix : `/${withoutPrefix}`;
  return `${getLangPrefix(nextLang)}${finalPath === "/" ? "" : finalPath}`;
};
